/**
 * Renders a number to two decimal places, keeping the original when rounding
 * would lose precision. Anything that is not a finite number is bracketed so a
 * bad value is visible rather than silently formatted.
 */
const formatAmount = (value: unknown): string => {
  if (Number.isFinite(value)) {
    const amount = value as number
    const fixed = amount.toFixed(2)

    return Number.parseFloat(fixed) === amount ? fixed : `${amount}`
  }

  if (value === '') return `''`

  // Stringifying an object to '[object Object]' is the point here: bracketed,
  // it tells the reader the field held something a number belonged in.
  // eslint-disable-next-line @typescript-eslint/no-base-to-string
  const text = String(value)

  return value ? `[${text}]` : text
}

export default formatAmount
